import script from "./AllyCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AllyCard.vue?vue&type=script&setup=true&lang=js"

import "./AllyCard.vue?vue&type=style&index=0&id=51093f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51093f32"]])

export default __exports__